/* import __COLOCATED_TEMPLATE__ from './example-question-suggestions-list.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import Component from '@glimmer/component';
import { answerListAcceptRejectTransition } from 'embercom/transition-maps/answers-transitions';

export default class ExampleQuestionSuggestionList extends Component {
  transition = answerListAcceptRejectTransition;
}
